import { render } from "./HeaderSort.vue?vue&type=template&id=dd66c338&scoped=true"
import script from "./HeaderSort.vue?vue&type=script&lang=js"
export * from "./HeaderSort.vue?vue&type=script&lang=js"

import "./HeaderSort.vue?vue&type=style&index=0&id=dd66c338&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd66c338"]])

export default __exports__